/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { CreateNewCampaign } from "@/Components/Brand/Sidebar/Sidebar";
import { useBrand } from "@/Providers/Brand";
import { Button } from "@/shadcnComponents/ui/button";
import { Card, CardContent } from "@/shadcnComponents/ui/card";
import { Dialog, DialogContent } from "@/shadcnComponents/ui/dialog";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import axios from "axios";
import { CampaignCreationSteps, UseCasesList } from "@/Helpers/helper";
import { DashBoardTasks } from "./DashBoardTasks";
import { LivePerformanceBoard } from "./LivePerformanceBoard";
// import { ScrollArea } from "../../../../shadcnComponents/ui/scroll-area";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

export const NewDashBoard: React.FC = () => {
  const initialRef = useRef(false);
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const brandState = useBrand();

  const [, setAllCampaigns] = useState({
    data: {},
    allCollabCount: 3,
    liveCollabCount: 0,
    draftCollabCount: 1,
    reviewCollabCount: 1,
  });
  const [brand, setBrand] = useState<{ data1?: { CompanyName?: string } }>({});

  useEffect(() => {
    if (initialRef.current) return;
    if (cookies.unlockCreatorSearch) {
      navigate("/Brand/DashBoard/CollabWithInfluencer");
    }
    const fetchBrandInfo = async () => {
      const brandInfo = await brandState?.getBrandInfo();
      setBrand(brandInfo);
    };
    fetchBrandInfo();

    const fetchAllCampaigns = async () => {
      const resAllCampaign = await axios.get(
        `${host}/collabs/brand/getAllCollab`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      setAllCampaigns({
        data: resAllCampaign?.data,
        allCollabCount: resAllCampaign?.data?.AllCollabs?.length,
        liveCollabCount: resAllCampaign?.data?.LiveCollabs?.length,
        draftCollabCount: resAllCampaign?.data?.draftCollabs?.length,
        reviewCollabCount: resAllCampaign?.data?.reviewCollabs?.length,
      });
    };
    fetchAllCampaigns();

    initialRef.current = true;
  }, [cookies.unlockCreatorSearch, navigate, brandState]);

  // Campaign Creation Steps Dialog
  const [selectedUseCase, setSelectedUseCase] = useState<UseCase | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOnOpenChange = (isOpen: boolean) => {
    setIsPopupOpen(isOpen);
  };

  const handleUseCaseClick = (useCase: UseCase) => {
    setSelectedUseCase(useCase);
    handleOnOpenChange(true);
  };

  return (
    <>
      <div className="w-full min-h-full font-inter flex flex-col py-5 px-10 overflow-auto bg-white">
        <div className="flex justify-between">
          {brand?.data1?.CompanyName ? (
            <h1 className="text-2xl">
              Welcome, <b>{brand?.data1?.CompanyName}</b>! 👋
            </h1>
          ) : (
            // shimmer
            <div className="flex gap-4">
              <div className="w-72 h-8 bg-gray-200 rounded-md animate-pulse"></div>
            </div>
          )}
        </div>
        <main className="w-full gap-[15px] flex flex-col mt-[20px]">
          {
            <>
              {/* {AllCampaigns?.liveCollabCount > 0 && <LivePerformanceBoard />} */}

              <LivePerformanceBoard />

              {/* Task section */}
              <DashBoardTasks />

              {/* ----- use case section ------- */}
              <section className="w-full">
                <div className="rounded-xl border border-[#E7E8F7] p-6">
                  <h1 className="font-bold text-xl">Use Cases</h1>
                  <p className="text-muted-foreground mb-8">
                    Explore these possible use cases to get started with
                    influencer marketing on LinkedIn
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
                    {isPopupOpen && selectedUseCase && (
                      <GuideDialog
                        open={isPopupOpen}
                        handleOnOpenChange={handleOnOpenChange}
                        data={selectedUseCase}
                      />
                    )}
                    {UseCasesList?.map((useCase, index) => (
                      <IMUseCaseCardLg
                        key={index}
                        title={useCase?.title}
                        description={useCase?.description}
                        image_link={useCase?.image_link}
                        onClick={() => handleUseCaseClick(useCase)}
                      />
                    ))}
                  </div>
                </div>
              </section>
              {/* ---------- How it works --------- */}
              <section className="w-full">
                <div className="rounded-xl border border-[#E7E8F7] p-6">
                  <h1 className="font-bold text-xl">How it works?</h1>
                  <p className="text-muted-foreground mb-8">
                    Only 5 steps to execute your campaign, hassle-free
                  </p>
                  <div
                    className="flex gap-4 overflow-y-scroll"
                    style={{ scrollbarWidth: "none" }}
                  >
                    {CampaignCreationSteps?.map((step, index) => (
                      <div className="rounded-lg border border-[#E7E8F7]">
                        <HowStepsCard
                          key={index}
                          step={step?.step}
                          title={step?.title}
                          description={step?.description}
                          note={step?.note}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </section>
              {/* ---------- Why anchors? --------- */}
              {/* <section className="w-full">
                <div className="rounded-xl border border-[#E7E8F7] p-6">
                  <h1 className="font-bold text-xl">Why anchors?</h1>
                  <p className="text-muted-foreground mb-8">
                    Explore our pre-built use cases to get started with influencer marketing.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    hi
                  </div>
                </div>
              </section> */}
            </>
          }
        </main>
      </div>
    </>
  );
};

interface IMUseCaseCard {
  key?: any;
  inDialog?: boolean;
  title: string;
  description: string | JSX.Element;
  image_link: string;
  onClick?: () => void;
}

const IMUseCaseCardLg: React.FC<IMUseCaseCard> = ({
  title,
  description,
  image_link,
  onClick,
}) => {
  return (
    <>
      <Card
        className="cursor-pointer hover:bg-muted transition-colors duration-200"
        onClick={onClick}
      >
        <CardContent className="p-6 grid gap-4">
          <img
            src={image_link}
            alt={title}
            className="rounded-md object-cover h-40 w-full"
          />
          <div>
            <h3 className="text-xl font-semibold">{title}</h3>
            <p className="text-muted-foreground">{description}</p>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

interface UseCase {
  title: string;
  description: JSX.Element;
  image_link: string;
}
interface GuideDialogProps {
  open: boolean;
  handleOnOpenChange: (isOpen: boolean) => void;
  data?: UseCase;
}

const GuideDialog: React.FC<GuideDialogProps> = ({
  open,
  handleOnOpenChange,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };
  const handlePreviousStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={handleOnOpenChange}>
      <DialogContent className="font-inter max-w-2xl min-h-[400px] rounded-xl">
        <div className="flex justify-between flex-col">
          <div className="flex flex-col flex-1">
            <div className="flex flex-1 duration-700 ease-in-out gap-4">
              <div className="w-5/12 p-4 overflow-clip">
                <img
                  src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/how+it+works.png"
                  alt=""
                  className="rounded-xl object-cover w-full h-80"
                />
              </div>

              {/* --------- body part ------------- */}
              <div className="w-7/12 flex flex-col">
                <div className="h-full flex flex-col justify-between p-4 gap-3">
                  <div className="pt-5">
                    <h1 className="text-sm text-muted-foreground leading-none uppercase">
                      Step: {currentStep}
                    </h1>
                    <h3 className="text-lg font-bold py-3">
                      {CampaignCreationSteps?.[currentStep - 1]?.title}
                    </h3>
                    <div
                      className="h-[180px] overflow-x-auto"
                      style={{
                        scrollbarWidth: "thin",
                        scrollbarColor: "#bc1f96 #f3f4f6",
                      }}
                    >
                      <p className="text-sm font-thin leading-5">
                        {CampaignCreationSteps?.[currentStep - 1].description}
                      </p>

                      {CampaignCreationSteps?.[currentStep - 1]?.note && (
                        <div>
                          <p className="text-sm text-muted-foreground mt-2">
                            Note:{" "}
                            {CampaignCreationSteps?.[currentStep - 1]?.note}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-start gap-2 items-center">
                    <div className="flex gap-4">
                      <Button
                        variant="ghost"
                        size="icon"
                        className="border border-black/20 rounded-full"
                        onClick={handlePreviousStep}
                        disabled={currentStep === 1}
                      >
                        <ArrowLeftIcon size={18} />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="border border-black/20 rounded-full"
                        onClick={handleNextStep}
                        disabled={currentStep === CampaignCreationSteps.length}
                      >
                        <ArrowRightIcon size={18} />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            {isPopupOpen && (
              <CreateNewCampaign
                open={isPopupOpen}
                handleOnOpenChange={(isOpen) => setIsPopupOpen(isOpen)}
                showTrigger={false}
              />
            )}
            <Button variant="destructive" onClick={() => setIsPopupOpen(true)}>
              Create New Campaign
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const HowStepsCard = ({ step, title, description, note }) => {
  return (
    <div className="flex justify-between flex-col w-[400px] h-[250px]">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 items-center duration-700 ease-in-out">
          <div className="w-5/12 p-3 overflow-clip">
            <img
              src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/how+it+works.png"
              alt=""
              className="rounded-xl object-cover w-full"
            />
          </div>

          {/* --------- body part ------------- */}
          <div className="w-full flex flex-col">
            <div className="h-full flex flex-col justify-between p-3 gap-2">
              <div
                style={{
                  scrollbarWidth: "thin",
                  scrollbarColor: "#bc1f96 #f3f4f6",
                }}
                className="pt-3 h-[180px] overflow-y-auto"
              >
                <h1 className="text-xs text-muted-foreground leading-none uppercase">
                  Step: {step}
                </h1>
                <h3 className="text-base font-bold py-1">{title}</h3>
                <p className="text-sm font-thin ">{description}</p>
                {note && (
                  <div>
                    <p className="text-sm text-muted-foreground mt-2 ">
                      Note: {note}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
